import withComponent from '@/hoc/withComponent';
import React, { useEffect, useRef, useState } from 'react';
import useForceUpdate from '@/hooks/useForceUpdate';
import FlexStyled from '@/styled/FlexStyled';
import { Button, Tooltip } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import isLogin from '@/common/isLogin';

const SaveComponentStyled = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;

  :hover {
    color: #019885;
  }
  svg {
    path {
      fill: #999999;
    }
  }
`;
const icon1 = <div
  style={{ height: 18, width: 18, marginRight: 4 }}
  dangerouslySetInnerHTML={{
    __html: `<svg width='18px' height='18px' viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
    <g id='优化页面' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='离线中状态--提示文案' transform='translate(-508.000000, -309.000000)' fill='#EC5B59'>
            <g id='文本备份-20' transform='translate(508.000000, 309.000000)'>
                <g id='tishi-4' transform='translate(3.000000, 3.000000)'>
                    <path d='M6,12 C2.68628571,12 0,9.31371429 0,6 C0,2.68628571 2.68628571,0 6,0 C9.31371429,0 12,2.68628571 12,6 C12,9.31371429 9.31371429,12 6,12 Z M6,0.856714289 C3.15942857,0.856714289 0.857142855,3.15942857 0.857142855,5.99957143 C0.857142855,8.84014286 3.15942857,11.1424286 6,11.1424286 C8.84014286,11.1424286 11.1428571,8.84014286 11.1428571,5.99957143 C11.1428571,3.15942857 8.84014286,0.856714289 6,0.856714289 Z M5.77142857,8.57142857 L6.22857143,8.57142857 C6.33902838,8.57142857 6.42857143,8.66097162 6.42857143,8.77142857 L6.42857143,9.22814286 C6.42857143,9.33859981 6.33902838,9.42814286 6.22857143,9.42814286 L5.77142857,9.42814286 C5.66097162,9.42814286 5.57142857,9.33859981 5.57142857,9.22814286 L5.57142857,8.77142857 C5.57142857,8.66097162 5.66097162,8.57142857 5.77142857,8.57142857 Z M6.21428571,7.71428571 L5.78571429,7.71428571 C5.66742857,7.71428571 5.57142857,7.61828571 5.57142857,7.5 L5.57142857,2.78528571 C5.57142857,2.667 5.66742857,2.571 5.78571429,2.571 L6.21428571,2.571 C6.33257143,2.571 6.42857143,2.667 6.42857143,2.78528571 L6.42857143,7.5 C6.42857143,7.61828571 6.33257143,7.71428571 6.21428571,7.71428571 Z' id='形状'></path>
                </g>
            </g>
        </g>
    </g>
</svg>`,
  }}
/>;

export const icon22 = <div style={{width: 24, height: 24}} dangerouslySetInnerHTML={{
    __html: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="秒出助手/智能排版" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
          <g id="单页编辑-小助手优化" transform="translate(-396.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
              <g id="编组-2" transform="translate(396.000000, 18.000000)">
                  <g id="编组" transform="translate(2.199997, 4.660000)">
                      <path d="M13.6470975,8.54788288 C13.9443978,8.75323464 14.0200371,9.16781487 13.8144758,9.46541858 L10.4068339,14.4002386 C10.2814392,14.582359 10.0758863,14.6859725 9.85536791,14.6844107 C9.67910104,14.6844107 9.51187935,14.6167584 9.38785197,14.492731 L6.88132848,11.9862075 C6.62731459,11.7321936 6.62731459,11.313959 6.88132848,11.0599451 C7.13534238,10.8059312 7.553577,10.8059312 7.80759089,11.0599451 L9.76142386,13.0137781 L12.729587,8.71522464 C12.9349135,8.4179609 13.3494938,8.34232155 13.6470975,8.54788288 Z" id="路径"></path>
                      <path d="M9.59074241,0.00273575068 L9.85900252,0 C12.7753659,0.033000061 15.3821523,1.88363837 16.3821347,4.63141597 L16.5019406,4.75105567 C18.3192023,5.40954579 19.5559834,7.05940441 19.5988748,8.86084447 L19.5985481,9.06687205 C19.5417167,11.188605 17.8392349,13.0726023 15.5582869,13.420995 L15.1580025,13.418 L15.1390546,13.4164662 C14.7240583,13.4164662 14.3887669,13.0811747 14.3887669,12.6661785 C14.3887669,12.2511822 14.7240583,11.9158908 15.1390546,11.9158908 L15.2866287,11.9158908 C16.9071177,11.8169536 18.1675579,10.4843425 18.1675579,8.86726377 L18.1624169,8.68864732 C18.0771265,7.21105217 16.9404156,6.01517563 15.4878035,5.83878571 L15.2920025,5.821 L15.3279847,5.97485872 C14.7780781,3.38512756 12.4809948,1.5032127 9.79955584,1.5032127 L9.55688541,1.50836437 C7.06101599,1.61449456 4.94076898,3.34994432 4.32589368,5.7414112 L4.30600252,5.821 L4.11130819,5.83878571 C2.6005916,6.02223123 1.4315538,7.30835347 1.4315538,8.86726377 L1.43654626,9.04280343 C1.51607123,10.4375138 2.53713921,11.5926363 3.88743175,11.8586822 L4.04700252,11.885 L4.04763986,11.9158908 L4.43322546,11.9158908 C4.84822169,11.9158908 5.18351313,12.2511822 5.18351313,12.6661785 C5.18351313,13.0465917 4.90177518,13.3600307 4.53516609,13.4096288 L4.4220456,13.4164662 L4.13584131,13.4187021 C1.76455183,13.0709502 -0.0257513874,11.0495564 0.000280269961,8.7913101 C0.0217492094,6.92565927 1.28555514,5.20513748 3.15631199,4.51591127 L3.27261627,4.40314272 C4.32121399,1.80691583 6.81649209,0.080429914 9.59074241,0.00273575068 Z" id="路径"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>`
  }}/>
  export const icon23 = <div style={{width: 24, height: 24}} dangerouslySetInnerHTML={{
    __html: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="秒出助手/智能排版" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
          <g id="单页编辑-小助手优化" transform="translate(-428.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
              <g id="编组-2" transform="translate(396.000000, 18.000000)">
                  <g id="文本备份-13" transform="translate(32.000000, 0.000000)">
                      <g id="编组" transform="translate(2.199997, 4.660000)">
                          <path d="M9.85900252,0 C12.7753659,0.033000061 15.3821523,1.88363837 16.3821347,4.63141597 L16.5019406,4.75105567 C18.3192023,5.40954579 19.5559834,7.05940441 19.5988748,8.86084447 L19.5985481,9.06687205 C19.5417167,11.188605 17.8392349,13.0726023 15.5582869,13.420995 L15.1580025,13.418 L15.1390546,13.4164662 C14.7240583,13.4164662 14.3887669,13.0811747 14.3887669,12.6661785 C14.3887669,12.2511822 14.7240583,11.9158908 15.1390546,11.9158908 L15.2866287,11.9158908 C16.9071177,11.8169536 18.1675579,10.4843425 18.1675579,8.86726377 L18.1624169,8.68864732 C18.0771265,7.21105217 16.9404156,6.01517563 15.4878035,5.83878571 L15.2920025,5.821 L15.302,5.864 L15.273218,5.7414112 C14.638508,3.27280023 12.3997391,1.5032127 9.79955584,1.5032127 L9.55688541,1.50836437 C7.06101599,1.61449456 4.94076898,3.34994432 4.32589368,5.7414112 L4.30600252,5.821 L4.11130819,5.83878571 C2.6005916,6.02223123 1.4315538,7.30835347 1.4315538,8.86726377 L1.43654626,9.04280343 C1.51607123,10.4375138 2.53713921,11.5926363 3.88743175,11.8586822 L4.04700252,11.885 L4.04763986,11.9158908 L4.43322546,11.9158908 C4.84822169,11.9158908 5.18351313,12.2511822 5.18351313,12.6661785 C5.18351313,13.0465917 4.90177518,13.3600307 4.53516609,13.4096288 L4.4220456,13.4164662 L4.13584131,13.4187021 C1.76455183,13.0709502 -0.0257513874,11.0495564 0.000280269961,8.7913101 C0.0217492094,6.92565927 1.28555514,5.20513748 3.15631199,4.51591127 L3.27261627,4.40314272 C4.32121399,1.80691583 6.81649209,0.080429914 9.59074241,0.00273575068 L9.85900252,0 Z M6.66956774,9.34 C7.14981535,9.34 7.53913296,9.72931761 7.53913296,10.2095652 C7.53913296,10.6898128 7.14981535,11.0791304 6.66956774,11.0791304 C6.18932013,11.0791304 5.80000252,10.6898128 5.80000252,10.2095652 C5.80000252,9.72931761 6.18932013,9.34 6.66956774,9.34 Z M9.80000252,9.34 C10.2802501,9.34 10.6695677,9.72931761 10.6695677,10.2095652 C10.6695677,10.6898128 10.2802501,11.0791304 9.80000252,11.0791304 C9.31975492,11.0791304 8.93043731,10.6898128 8.93043731,10.2095652 C8.93043731,9.72931761 9.31975492,9.34 9.80000252,9.34 Z M12.9304373,9.34 C13.4106849,9.34 13.8000025,9.72931761 13.8000025,10.2095652 C13.8000025,10.6898128 13.4106849,11.0791304 12.9304373,11.0791304 C12.4501897,11.0791304 12.0608721,10.6898128 12.0608721,10.2095652 C12.0608721,9.72931761 12.4501897,9.34 12.9304373,9.34 Z" id="形状结合"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>`
  }}/>
export const errorIcon = <div style={{width: 24, height: 24}} dangerouslySetInnerHTML={{
  __html: `<?xml version="1.0" encoding="UTF-8"?>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>切片</title>
      <g id="匿名用户登录提示" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="编辑内容后-提示保存失败" transform="translate(-190.000000, -13.000000)" fill="#EC5B59">
              <g id="文本备份-12" transform="translate(190.000000, 13.000000)">
                  <path style="fill:#EC5B59;" d="M12.0601315,4.5600064 L11.7897201,4.56274095 C8.96782575,4.64175356 6.44107844,6.39829503 5.37989107,9.02569268 L5.28669849,9.10411773 C3.41586963,9.78423933 2.12227562,11.5391199 2.10028437,13.4501594 C2.07359284,15.7656496 3.90787984,17.8237092 6.32132889,18.1776438 L6.6228243,18.1764631 L6.74119684,18.1694467 C7.16797853,18.1119848 7.4835106,17.7534343 7.4835106,17.3261785 L7.47689588,17.2193975 C7.42450588,16.7997314 7.06727651,16.4758908 6.63322293,16.4758908 L6.288,16.475 L6.26327303,16.4463329 L6.10370226,16.4200151 C4.79446375,16.1620088 3.81291621,15.0393767 3.73638157,13.6971108 L3.73151086,13.5244209 C3.73155128,12.0312677 4.8504907,10.7769063 6.32336007,10.5980565 L6.51509731,10.5805853 L6.60301598,10.5052466 L6.62290714,10.4256578 L6.68614792,10.1996506 C7.36410728,7.9608256 9.39723315,6.36879255 11.7611313,6.26827408 L11.9995533,6.2632127 C14.5375471,6.2632127 16.7488749,7.98578035 17.3763655,10.4263125 L17.4046477,10.5468589 L17.487,10.527 L17.4829537,10.58059 L17.6787546,10.5983757 C19.0861214,10.7693176 20.1804128,11.9309129 20.2625806,13.35441 L20.2675967,13.5301408 C20.2675554,15.0909603 19.0487784,16.3803291 17.4805321,16.4760767 L17.339052,16.4758908 C16.8688273,16.4758908 16.4887644,16.8559538 16.4887644,17.3261785 C16.4887644,17.7602321 16.812605,18.1174614 17.2322711,18.1698514 L17.3499314,18.177674 L17.7575362,18.1809922 C20.0827463,17.8271157 21.8398803,15.9184088 21.8985097,13.7295496 L21.8988721,13.521003 C21.8548748,11.6717625 20.5880705,9.98813876 18.7360058,9.31703764 L18.6527938,9.22065623 C17.6619273,6.47043993 15.0182436,4.59347887 12.0601315,4.5600064 Z" id="路径"></path>
                  <path style="fill:#EC5B59;" d="M10.135913,13.5419894 L12,15.406 L13.864087,13.5419894 C14.0837569,13.3223195 14.4399122,13.3223195 14.6595821,13.5419894 L14.9080106,13.7904179 C15.1276805,14.0100878 15.1276805,14.3662431 14.9080106,14.585913 L13.044,16.45 L14.9080106,18.314087 C15.1276805,18.5337569 15.1276805,18.8899122 14.9080106,19.1095821 L14.6595821,19.3580106 C14.4399122,19.5776805 14.0837569,19.5776805 13.864087,19.3580106 L12,17.494 L10.135913,19.3580106 C9.91624313,19.5776805 9.56008783,19.5776805 9.34041791,19.3580106 L9.09198941,19.1095821 C8.8723195,18.8899122 8.8723195,18.5337569 9.09198941,18.314087 L10.956,16.45 L9.09198941,14.585913 C8.8723195,14.3662431 8.8723195,14.0100878 9.09198941,13.7904179 L9.34041791,13.5419894 C9.56008783,13.3223195 9.91624313,13.3223195 10.135913,13.5419894 Z" id="形状结合"></path>
              </g>
          </g>
      </g>
  </svg>`
}}/>

const MenuStyled = styled.div`
  position: absolute;
  bottom: -10px;
  left: -20px;
  transform: translateY(100%);
  width: 192px;
  height: 108px;
  background: #FFFFFF;
  box-shadow: 0px 1px 14px 0px rgba(76,76,76,0.29);

  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px 24px;
  border-radius: 8px;

  &::after {
    position: absolute;
    top: -20px;
    left: 60px;
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid #fff;
    filter: drop-shadow(0 -2px 2px rgba(76,76,76,0.19));
  }
`

export default withComponent((props) => {
  const { style, setLoginVisible } = props;
  const websocketStatus = useSelector(state => state.edit)
  const [isLoginTip, setIsLoginTip] = useState(false)
  const that = useRef({
    saving: false,
    saveDate: undefined,
  }).current;
  const [, update] = useForceUpdate();

  useEffect(() => {
    if (!isLogin()) {
      setTimeout(() => {
        setIsLoginTip(true)
      }, 3000)
    }
  }, [])

  if (
    Date.parse(new Date(that.saveDate).toString()) <
    Date.parse(new Date(websocketStatus?.date).toString())
  ) {
    that.saveDate = websocketStatus?.date;
  }
  let title;
  let text;

  if (websocketStatus?.status && websocketStatus?.status === 'close') {
    title = '';
  } else if (websocketStatus?.status && websocketStatus?.status === 'error') {
    title = '保存失败';
  } else if (that.saving || websocketStatus?.status && websocketStatus?.status === 'saving') {
    title = '保存中…';
  } else {
    title = '所有更改已保存';
  }
  if (websocketStatus?.status && websocketStatus?.status === 'close') {
    text = '离线中';
  } else if (websocketStatus?.status && websocketStatus?.status === 'error') {
    text = (
      <FlexStyled $alignItems='center'>
        {icon1}
        离线中
      </FlexStyled>
    );
  } else if (that.saving || websocketStatus?.status && websocketStatus?.status === 'saving') {
    text = <div>{icon23}</div>;
  } else {
    text = <div>{icon22}</div>;
  }

  // 针对匿名用户特殊处理
  if (isLoginTip) {
    title = "保存失败"
    text = (
      <FlexStyled style={{
        color: '#EC5B59',
        fontSize: 14
      }} $alignItems='center'>
        {errorIcon}
        <span style={{ marginLeft: 4 }}>保存失败</span>
      </FlexStyled>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      {(
        <Tooltip placement='bottom' title={title}>
          <SaveComponentStyled id="save_header_icon" style={style}>{text}</SaveComponentStyled>
        </Tooltip>
      )}
      {
        isLoginTip && 
        <MenuStyled>
          <p style={{ marginBottom: 13 }}>为了避免您修改数据丢失，请及时保存您修改的模板</p>

          <Button onClick={() => {
            setLoginVisible(true)
            setIsLoginTip(false)
          }} type='primary'>知道啦</Button>
        </MenuStyled>
      }
    </div>
  );
});
